
import useLoaderHook from "../../hooks/useLoaderHook";
import "./LoaderComponent.scss";

/**
*  LoaderComponent
*  @description component that renders the application loader       
*/

const LoaderComponent = () => {
    const { contatoreSpinner } = useLoaderHook();
    return (
        (contatoreSpinner ? <div className="loaderContainer">
            <div className="loader"></div>
        </div> : null)
    );
};

export default LoaderComponent;
